<div class="account-settings-tab-group-root"> 
  <mat-tab-group dynamicHeight [selectedIndex]="getSelectedIndex()">
    <mat-tab tab [label]="labels.account" id="lnr-front-account-tab">
      <ng-template mat-tab-label>
        <div class="tab-label">
          <mat-icon class="material-icons-outlined">account_circle</mat-icon>
          <span>{{labels.account}}</span>
        </div>
      </ng-template>
      <app-edit-account></app-edit-account>
    </mat-tab>
    <mat-tab tab [label]="labels.settings" id="lnr-front-settings-tab">
      <ng-template mat-tab-label>
        <div class="tab-label">
          <mat-icon class="material-icons">settings</mat-icon>
          <span>{{labels.settings}}</span>
        </div>
      </ng-template>
      <app-edit-settings></app-edit-settings>
    </mat-tab>
  </mat-tab-group>
</div>
